import ShopManagement from "./ShopManagement";

export default ShopManagement;
